/** Labels and explanatory copy around the enlarged cell inspector. */

export const cellZoomUi = {
  character: 'Character',
  foreground: 'Foreground',
  background: 'Background',
  attributes: 'Attributes',
  bold: 'Bold',
  underline: 'Underline',
  cellLinePrefix: 'Cell:',
  slash: '/',
  on: 'on',
  boldState: 'bold',
  underlineState: 'underlined',
  colorDepthHeading: 'Color Depth in Terminals',
  colorDepthLead:
    'Modern terminals support more than just 16 colors. Explore the different color modes available.',
  modes: {
    ansi16: { label: '16 Colors', subtitle: 'Classic ANSI' },
    ext256: { label: '256 Colors', subtitle: 'Extended palette' },
    truecolor: { label: 'Truecolor', subtitle: '16 million colors' },
  },
  original16: 'The Original 16 Colors',
  brightAbbrev: 'br',
  escapeFormatHeading: 'Escape sequence format:',
  fgPatternOpen: '^[[38;5;',
  fgPlaceholder: '<0-15>',
  fgPatternClose: 'm',
  fgRole: '— foreground',
  bgPatternOpen: '^[[48;5;',
  bgRole: '— background',
  palette256Heading: '256-Color Extended Palette',
  standard16Row: 'Standard 16 (0-15)',
  cube216: '6×6×6 Color Cube (16-231)',
  grayscale232: 'Grayscale (232-255)',
  truecolorHeading: '24-bit Truecolor (16 Million Colors)',
  sliders: {
    hue: 'Hue:',
    saturation: 'Saturation:',
    lightness: 'Lightness:',
    hueSuffix: '°',
    percentSuffix: '%',
  },
  rgbHeading: 'RGB',
  ansiTruecolorFg: '^[[38;2;',
  ansiTruecolorBg: '^[[48;2;',
  gradientCaption: 'Smooth gradient (only possible with truecolor)',
  comparisonHeading: 'Color count comparison:',
  counts: [
    { n: '16', label: 'Classic ANSI' },
    { n: '256', label: 'Extended' },
    { n: '16,777,216', label: 'Truecolor (24-bit)' },
  ],
} as const;
